import { TablePaginationOptions } from '../tables/tables.types';

export interface Notification {
  createdAt: Date;
  id: string;
  readAt: Date;
  text: string;
  type: string;
}

export enum UserDivision {
  CONTROL = 'Contrôle',
  DISPATCH = 'Expédition',
  PREPARATION = 'Préparation'
}

export enum UserCompanyRole {
  ADMIN = 'Admin',
  DIRECTION = 'Direction',
  TECHNICIEN = 'Technicien'
}

export enum UserRoleType {
  ACTION_ACCEPT_RETURN_PAYMENT = 'action_accept_return_payment',
  ACTION_BOOKED_B2B = 'action_booked_b2b',
  ACTION_BOOKED_MARKETING = 'action_booked_marketing',
  ACTION_CANCEL_TASKS_DEVICE_INFO = 'action_cancel_tasks_device_info',
  ACTION_DECLARE_ORDER_RETURN = 'action_declare_order_return',
  ACTION_DELETE_DEVICE = 'action_delete_device',
  ACTION_DELETE_FAILURE = 'action_delete_failure',
  ACTION_DELETE_ORDER_LINE = 'action_delete_order_line',
  ACTION_DELETE_ORDER_RETURN = 'action_delete_order_return',
  ACTION_FINISH_PURCHASE_CONTROL = 'action_finish_purchase_control',
  ACTION_GENERATE_REPORT = 'action_generate_report',
  ACTION_OUT_OF_STOCK_PROPOSAL = 'action_out_of_stock_proposal',
  ACTION_PARTIAL_CREDIT_NOTE = 'action_partial_credit_note',
  ACTION_PRINT_CARRIER_LABEL = 'action_print_carrier_label',
  ACTION_PRINT_UNPACKING_LABEL = 'action_print_unpacking_label',
  ACTION_RESET_CARRIER_LABEL = 'action_reset_carrier_label',
  ACTION_SEE_MATCHING_ERROR = 'action_see_matching_error',
  ACTION_UNLOCK_PURCHASE_PAYMENT = 'action_unlock_purchase_payment',
  ACTION_MATCH_HS_PROPOSAL = 'action_match_hs_proposal',
  ACTION_UNMATCH = 'action_unmatch',
  ACTION_UPDATE_ORDER_SHIPPING_DATE = 'action_update_order_shipping_date',
  ACTION_DEROGATION_QUALITE = 'action_derogation_qualite',
  ADMIN = 'admin',
  ADV_ACCESS = 'adv_access',
  ANALYTICS_ACCESS = 'analytics_access',
  CONTROL_CONTROL_COMPUTER = 'control_control_computer',
  CONTROL_GRADING = 'control_grading',
  CONTROL_MANAGEMENT = 'control_management',
  CONTROL_UNPACKING = 'control_unpacking',
  CONTROL_WARRANTY_NC = 'control_warranty_nc',
  MANAGEMENT_MAJ_ALGO_COST = 'management_maj_algo_cost',
  MANAGEMENT_MAJ_REPAIR_COST = 'management_maj_repair_cost',
  MANAGEMENT_MASS_STATUS_CHANGE = 'management_mass_status_change',
  MANAGEMENT_MAJ_INVOICES = 'management_maj_invoices',
  MANAGEMENT_SHIP_ORDER = 'management_ship_order',
  MANAGEMENT_BATCH_STOCK_WITHDRAWAL = 'management_batch_stock_withdrawal',
  MANAGEMENT_UK_COMPUTER_TRANSFER = 'management_uk_computer_transfer',
  MANAGEMENT_UK_INVOICE_CREDIT_NOTE = 'management_uk_invoice_credit_note',
  ACCOUNTING_MEMBER = 'accounting_member',
  MATCHING_ASSO = 'matching_asso',
  MATCHING_DEPOSIT = 'matching_deposit',
  MATCHING_PICKING = 'matching_picking',
  MATCHING_PRINT_LABEL = 'matching_print_label',
  PRODUCTION_MANAGEMENT = 'production_management',
  PRODUCTION_CAGE_MANAGEMENT = 'production_cage_management',
  PRODUCTION_CLEANING = 'production_cleaning',
  PRODUCTION_KEY_CHANGE = 'production_key_change',
  PRODUCTION_PACKAGING = 'production_packaging',
  PRODUCTION_QUALITY_CONTROL = 'production_quality_control',
  PRODUCTION_REPAIR = 'production_repair',
  PURCHASE_ORDER = 'purchase_order',
  PURCHASE_RECEPTION = 'purchase_reception',
  PURCHASE_STOCK = 'purchase_stock',
  PURCHASE_SUPPLIER = 'purchase_supplier',
  SAV_RC_ACCESS = 'sav_rc_access',
  BUYBACK_ACCESS = 'buyback_access',
  BUYBACK_RECEPTION = 'buyback_reception',
  BUYBACK_KYPSELI = 'buyback_kypseli',
  BUYBACK_EXPEDITION = 'buyback_expedition',
  BUYBACK_CONTROL = 'buyback_control',
  BUYBACK_ACHAT = 'buyback_achat',
  BUYBACK_ADMIN = 'buyback_admin',
  CRM_USER = 'crm_user',
  CRM_CLIENT_BLOCKED = 'crm_client_blocked',
  FAST_REGRADING = 'fast_regrading',
  SPECIAL_PROCESS_ELIGIBILITY_TABLE = 'special_process_eligibility_table',
  SPECIAL_PROCESS_DISMANTLE = 'special_process_dismantle',
  SPECIAL_PROCESS_ASSEMBLE = 'special_process_assemble',
  SPECIAL_PROCESS_REPAIR = 'special_process_repair'
}

export interface UserRole {
  name: UserRoleType;
}

export interface User {
  avatar_url: string;
  company_role: UserCompanyRole;
  created_at: string;
  division: UserDivision;
  email: string;
  first_name: string;
  id?: string;
  last_name: string;
  notifications: Notification[];
  roles: UserRole[];
  /* Rôles individuels uniquement (hors héritage d'équipe) — renvoyé par
   * POST/DELETE /users/:id/roles, à distinguer de `roles` (effectifs) */
  direct_roles?: UserRole[];
  /* Équipes dont l'utilisateur est membre (renvoyé par index/show/add_role/remove_role) */
  teams?: { id: number; name: string; task_assignable?: boolean }[];
  /* Présent (non nul) si l'utilisateur a été désactivé (POST /users/:id/disable) */
  disabled_at?: string | null;
  session_id: string;
  updated_at: string;
  userid: string;
}

export interface UsersList {
  count: number;
  values: User[];
}

export interface UsersListOptions {
  filters?: Partial<Record<keyof User, string[]>>;
  pagination?: TablePaginationOptions;
  /* Inclut les utilisateurs désactivés dans le résultat (réservé à l'écran d'admin) */
  includeDisabled?: boolean;
}

export interface ChangePasswordOptions {
  current_password: string;
  new_password: string;
  new_password_conf: string;
}
